// AppInitializer.jsx
import React, { useEffect, useState } from 'react';
import AppLoaderPage from './AppLoaderPage';
import SystemRoutes from '../Nav/SystemRoutes';
import { useAuth } from '../DataStore/AuthContext';
import NoAccessPage from './NoAccessPage';

const AppInitializer = () => {
  const { getProfiles, getMyPermissions, activeProfile, myPermissions } = useAuth();
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const bootApp = async () => {
      try {
        await getProfiles();
        await getMyPermissions();
      } finally {
        setInitializing(false);
      }
    };

    bootApp();
  }, []);

  if (initializing || !myPermissions) {
    return <AppLoaderPage />;
  }

  if (myPermissions === '404' && activeProfile) {
    return <NoAccessPage />;
  }



  return <SystemRoutes />;
};

export default AppInitializer;
